module.exports = __webpack_public_path__ + "assets/img/w_d_i_10.00adb1d4.jpg";